import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for EditAlgo
export const EditAlgo = createSlice({
  name: "EditAlgo",
  initialState: {
    isLoading: false,
    isSuccess: false,
    api_completed: false,
    isFirst: true,
    switchResponse: false,
    data: [],
  },
  reducers: {
    edit_EditAlgo: (state, _) => {
      state.isLoading = true;
    },
    success_api_call_EditAlgo: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
      state.isFirst = true;
      state.switchResponse = true;
    },
    failure_api_call_EditAlgo: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.api_completed = true;
      state.isSuccess = false;
      state.switchResponse = true;
    },
    EditAlgo_is_success: (state) => {
      state.isSuccess = false;
    },
    EditAlgo_complete_api: (state) => {
      state.api_completed = false;
    },
    false_switchalgo_response: (state) => {
      state.switchResponse = false;
    },
  },
});
export default EditAlgo.reducer;
export const {
  edit_EditAlgo,
  success_api_call_EditAlgo,
  EditAlgo_complete_api,
  failure_api_call_EditAlgo,
  EditAlgo_is_success,
  false_switchalgo_response
} = EditAlgo.actions;
